var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"bottomTc"}),_c('div',{staticClass:"bottomTip"},[(_vm.email)?_c('div',[_vm._v("客服邮箱："+_vm._s(_vm.email))]):_vm._e(),_c('div',[_vm._v("@2022瑞森港通")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }